import script from "./ModalUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalUser.vue?vue&type=script&setup=true&lang=js"

import "./ModalUser.vue?vue&type=style&index=0&id=4ee63451&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee63451"]])

export default __exports__